import React, { useState, useRef } from 'react';
import { useMDCockpit } from '../../../hooks/useMDCockpit';
import SatelliteSection from '../Satellite/components/SatelliteSection';
import GeoFeatureSection from '../GeoFeature/components/GeoFeatureSection';
import GroundStationSection from '../GroundStation/components/GroundStationSection';
import styles from '../LeftSideBar.module.scss';

/**
 * ModellingTree - Main Orchestrator
 *
 * Responsibility:
 * - Render three tree sections (Satellites, GeoFeatures, Ground Stations)
 * - Manage collapsed/expanded state for each section
 * - Provide main container for tree UI
 *
 * Each section handles its own:
 * - State management (search, sort, selection, deletion)
 * - API calls (CRUD operations)
 * - Event handling (click, hover, context menu)
 * - Cesium highlighting/visualization
 */
const ModellingTree: React.FC = () => {
  const { shouldBlockUI } = useMDCockpit();
  const treeRef = useRef<HTMLDivElement>(null);

  const [collapsedSections, setCollapsedSections] = useState({
    satellites: false,
    geofeatures: false,
    ground: false,
  });

  const toggleSection = (key: keyof typeof collapsedSections) => {
    setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={styles.threePanel} ref={treeRef}>
      {/* Satellites Section */}
      <SatelliteSection
        collapsed={collapsedSections.satellites}
        onToggleCollapsed={() => toggleSection('satellites')}
        disabled={shouldBlockUI}
      />

      {/* GeoFeatures Section */}
      <GeoFeatureSection
        collapsed={collapsedSections.geofeatures}
        onToggleCollapsed={() => toggleSection('geofeatures')}
        disabled={shouldBlockUI}
      />

      {/* Ground Stations Section */}
      <GroundStationSection
        collapsed={collapsedSections.ground}
        onToggleCollapsed={() => toggleSection('ground')}
        disabled={shouldBlockUI}
      />
    </div>
  );
};

export default ModellingTree;
